<template>
  <transition name="fade">
    <v-alert
      v-if="visible"
      :type="type"
      elevation="10"
      border="left"
      colored-border
      class="notification-alert"
    >
      {{ message }}
    </v-alert>
  </transition>
</template>

<script>
export default {
  name: "NotificationAlert",
  data() {
    return {
      visible: false,
      type: "success",
      message: "",
    };
  },
  methods: {
    show({ message, type = "success", duration = 3000 }) {
      this.message = message;
      this.type = type;
      this.visible = true;

      setTimeout(() => {
        this.visible = false;
      }, duration);
    },
  },
};
</script>

<style scoped>
.notification-alert {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 9999;
  max-width: 300px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
